import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const upload = async (data: any) => {
  return httpRequest.upload("/api/general/upload", data);
};

export const init = async () => {
  return httpRequest.get("/prt/general/init");
};

export const dehubInit = async () => {
  return httpRequest.get(`/api/general/init`);
};

export const businessInit = async () => {
  return httpRequest.get(`/biz/general/init`);
};
